export default __webpack_public_path__ + "static/media/find.42873fb6.svg";